import React from 'react';

/**
 * 将接口返回的菜单数据转换为UmiJS路由格式
 * @param menus 接口返回的菜单数据
 * @returns UmiJS路由格式的菜单数据
 */
export const convertMenusToRoutes = (menus: any[] = []): any[] => {
    console.log('Converting menus to routes:', menus);
  return menus.map(menu => {
    const route = {
      path: menu.path,
      name: menu.name,
      icon: menu.icon ? createSvgIcon(menu.icon) : undefined,
      component: menu.component ? `./${menu.component}` : undefined,
      access: menu.access,
      routes: menu.children ? convertMenusToRoutes(menu.children) : undefined,
    };
    console.log('Created route:', route);
    return route;
  });
};

/**
 * 创建SVG Symbol图标组件
 * @param iconName 图标名称
 * @returns React组件
 */
const createSvgIcon = (iconName: string) => {
  return React.createElement('svg', {
    className: 'svgfont',
    style: { fontSize: 28 }
  }, React.createElement('use', {
    xlinkHref: `#icon-${iconName}`
  }));
};

/**
 * 根据模块类型过滤菜单
 * @param menus 所有菜单数据
 * @param moduleType 模块类型 ('workspace' | 'admin')
 * @returns 过滤后的菜单数据
 */
export const filterMenusByModule = (menus: any[] = [], moduleType: string): any[] => {
  if (moduleType === 'manage') {
    // 管理模块的菜单 - 过滤出管理相关的菜单
    return menus.filter(menu => 
      menu.path?.startsWith('/manage') || 
      menu.name?.includes('管理') ||
      menu.name?.includes('manage')
    );
  } else {
    // 工作台模块的菜单 - 过滤出工作台相关的菜单
    return menus.filter(menu => 
      !menu.path?.startsWith('/manage') && 
      !menu.name?.includes('管理') &&
      !menu.name?.includes('manage')
    );
  }
}; 